"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSmsRestrictionEditorCtl = /** @class */ (function (_super) {
    __extends(DlgSmsRestrictionEditorCtl, _super);
    function DlgSmsRestrictionEditorCtl() {
        return _super.call(this, true) || this;
    }
    DlgSmsRestrictionEditorCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            dialogTitle: "",
            visible: false,
            actionVal: 0,
            actionsAvail: [],
            completedAttemptsCount: 0,
            blockByMinutes: 0,
            isLocked: false,
            actionTitle: "",
            onNo: null
        };
    };
    DlgSmsRestrictionEditorCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSmsRestrictionEditorCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetOnNoClick = function (callback, forceUpdate) {
        this.DATA.onNo = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetOnNoClick = function () {
        return this.DATA.onNo;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetActions = function (bets, forceUpdate) {
        this.DATA.actionsAvail = bets;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetActions = function () {
        return this.DATA.actionsAvail;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetActionVal = function (Val, forceUpdate) {
        this.DATA.actionVal = Val;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetActionVal = function () {
        return this.DATA.actionVal;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetActionTitle = function (Val, forceUpdate) {
        this.DATA.actionTitle = Val;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetActionTitle = function () {
        return this.DATA.actionTitle;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetCompletedAttemptsVal = function (Val, forceUpdate) {
        this.DATA.completedAttemptsCount = Val;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetCompletedAttempts = function () {
        return this.DATA.completedAttemptsCount;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetBlockByMinutes = function (Val, forceUpdate) {
        this.DATA.blockByMinutes = Val;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetBlockByMinutes = function () {
        return this.DATA.blockByMinutes;
    };
    DlgSmsRestrictionEditorCtl.prototype.SetIsLocked = function (Val, forceUpdate) {
        this.DATA.isLocked = Val;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSmsRestrictionEditorCtl.prototype.GetIsLocked = function () {
        return this.DATA.isLocked;
    };
    return DlgSmsRestrictionEditorCtl;
}(BaseController_1.BaseController));
exports.DlgSmsRestrictionEditorCtl = DlgSmsRestrictionEditorCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSmsRestrictionEditorCtl.ts
// module id = 916
// module chunks = 0